<template>
    <header>
        <section id="headerSection" class="container top align-center">
            <div class="d-flex align-items-center" id="logo-container">
                <a href="/" style="text-decoration:none;" class="d-flex align-items-center">
                <img class="logo" :src="s3+'/images/my-healthy-staff-new-logo.svg'" alt="My Healthy Staff" />
            </a>
            </div>
    
            <div class="d-flex align-items-center justify-content-between">
                <div id="contact-numbers-container">
                    <p id="phone-numbers">
                        <span v-if="localTelNo">UK Wide: {{ localTelNo }}<br/></span>
                        <span v-if="internationalTelNo">Nat/Int: {{ internationalTelNo }}</span>
                    </p>
                </div>
    
                <div class="search-box">
                    <input type="text" class="form-control" placeholder="Search" v-model="q" v-on:keyup.enter="doSearch()" />
                    <button class="btn" type="button" v-on:click="doSearch()">
                <i class="fa fa-search"></i>
              </button>
                </div>
            </div>
        </section>
    
        <!--- Mobile Header --->
        <section id="headerSectionMob" class="align-center top">
            <div class="container">
                <div class="row">
                    <div class="col text-center">
                        <router-link to="/" style="text-decoration: none;">
                            <img class="logo" :src="s3+'/images/my-healthy-staff-new-logo.svg'" alt="My Healthy Staff" />
                        </router-link>
    
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12 d-flex justify-content-between align-items-center">
                        <p id="phone-numbers">
                            <span v-if="localTelNo">UK Wide: {{ localTelNo }}<br/></span>
                            <span v-if="internationalTelNo">Nat/Int: {{ internationalTelNo }}</span>
                        </p>
                        <div class="col-2">
                            <a class="toggle visible-xs hc-nav-trigger hc-nav-1 off-canvas-nav-on" data-off-canvas-nav="open">
                                <div id="mob-nav" class="btn-burger grey">
                                    <img :src="s3+'/images/menu.png'" style="width: 100%" alt="My Healthy Staff" />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- end -->
    
        <nav class="navbar navbar-expand-lg navbar-dark office-navbar">
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
    
            <div class="container">
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item active dropdown" data-toggle="collapse" data-target=".navbar-collapse.show" v-for="(menuItem, index) in this.headerMenu" v-bind:key="index">
                            <!-- <template v-if="menuItem.path=='/' || menuItem.path=='/lms-course'"> -->
                            <template v-if="menuItem.path=='/'">
                                <router-link class="nav-link" :to="menuItem.path">{{ menuItem.title }}<span class="sr-only">(current)</span></router-link>
                            </template>
                            <template v-else>
                                <a v-if="menuItem.path !='/lms-course'" href class="nav-link" :class="menuItem.subcats.length!=0 ? 'dropdown-toggle':''" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{ menuItem.title }}</a>
                            </template>
                            <div class="dropdown-menu" v-if="menuItem.subcats.length!=0" >
                                <router-link class="dropdown-item" v-for="(product, product_key) in menuItem.subcats" :to="product.path" v-bind:key="product_key">
                                    {{product.title}}
                                </router-link>
                            </div>
                        </li>
                    </ul>
    
                    <ul class="navbar-nav">
                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <router-link to="/help/about-us" class="nav-link">About Us</router-link>
                        </li>
                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <router-link to="/contact" class="nav-link">Contact Us</router-link>
                        </li>
                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <router-link to="/basket" class="nav-link">
                                My Basket
                                <i class="fa fa-shopping-cart ml-2 mr-1"></i>
                                <shopping-cart></shopping-cart>
                            </router-link>
                        </li>
                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                            <router-link to="/accounts" class="nav-link" v-if="$store.state.auth">My Account</router-link>
                            <router-link class="nav-link" to="/login" v-if="!$store.state.auth">
                                Login
                                <i class="fa fa-user ml-2"></i>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <nav id="mobile-nav" class="sidenav d-block d-lg-none sidenav">
            <div class="nav-container">
                <div class="nav-wrapper nav-wrapper-0">
                    <div class="nav-content">
                        <div class="mobile-nav-header">
                            <a id="close-btn" class="closebtn" data-off-canvas-nav="close" style="right: 10px; top: 10px">
                                <div id="myDIV" class="btn-burger grey">
                                    <img :src="s3+'/images/menu.png'" @click="Close()" style="width: 100%" alt="My Healthy Staff">
    
                                </div>
                            </a>
                            <router-link to="/" class="mob-link">Home</router-link>
                            <router-link to="/accounts" class="mob-link" v-if="$store.state.auth">My Account</router-link>
                            <router-link to="/login" class="mob-link" v-if="!$store.state.auth">
                                Login
                            </router-link>
                            <router-link to="/basket" class="mob-link">
                                My Basket
                                <i class="fa fa-shopping-cart ml-2 mr-1"></i>
                                <shopping-cart></shopping-cart>
                            </router-link>
                        </div>
    
                        <ul v-if="this.$route.name != 'quick guides more'" class="list-unstyled">
                            <li v-for="(menuItem, index) in this.headerMenu" v-bind:key="index" v-if="menuItem.path!='/'">
                                <a href="#" class="hasSubMenuLink collapsed" role="button" data-toggle="collapse" 
                                :href="'#' + makeSlug('submenuList'+index)" aria-expanded="false" aria-controls="mental-health">
                                    {{ menuItem.title }} 
                                    <i class="menuPlusSign fa fa-plus-circle"></i> 
                                    <i class="menuMinusSign fa fa-minus-circle"></i>
                                </a>
    
                                <ul :id="makeSlug('submenuList'+index)" v-if="menuItem.subcats" class="list-unstyled collapse prodSubMenu" data-parent="#mobile-nav">
                                    <li v-for="product in menuItem.subcats">
                                        <router-link class="mob-link subMenuText" :to="product.path">{{ product.title }}</router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <router-link class="mob-link" to="/help/about-us" >About Us</router-link>
                            </li>
                            <li>
                                <router-link class="mob-link" to="/contact">Contact Us</router-link>
                            </li>
                        </ul>

                        <ul v-if="this.$route.name == 'quick guides more'" class="list-unstyled">
                            <li v-for="quickguide in quickguides" v-if="quickguides">
                                <router-link :to="quickguide.path" class="collapsed mob-link" role="button" v-if="quickguide"> {{quickguide.title}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
        <div id="overlayWrapper" class="bg-wrapper" />
    </header>
</template>

<script>
import Axios from "axios";
import ShoppingCart from "../components/ShoppingCart.vue";
import Menu from "@/services/Menu";
import GenericMixin from "@/mixins/GenericMixin";

export default {
    name: "app-header",
    components: { ShoppingCart },
    mixins: [GenericMixin],
    data() {
        return {
            quickguides: [],
            headerMenu: [],
            s3: process.env.VUE_APP_CDN_IMAGE_URL,
            cx: process.env.VUE_APP_cx,
            custom_search_key: process.env.VUE_APP_custom_search_key,
            q: ""
        };
    },
    mounted() {
        Menu.getheadermenu()
            .then(request => {
                this.isLoading = false;
                this.headerMenu = request.data.data;
            })
            .catch(error => {});
        if (this.$router.currentRoute.name === "quick guides more") {
            Menu.getquickguidesmenu()
                .then(request => {
                    this.isLoading = false;
                    if (request.data) {
                        this.quickguides = request.data.data;
                    }
                })
                .catch(error => {});
        }
    },
    watch: {
        $route(to, from) {
            if (this.$router.currentRoute.name === "quick guides more") {
                Menu.getquickguidesmenu()
                    .then(request => {
                        this.isLoading = false;
                        if (request.data) {
                            this.quickguides = request.data.data;
                        }
                    })
                    .catch(error => {});
            }
        }
    },
    methods: {
        doSearch: function() {
            var app = this;
            Axios.get(
                    "https://www.googleapis.com/customsearch/v1?key=" + this.custom_search_key + "&cx=" + this.cx + "&q=" +
                    this.q
                )
                .then(function(response) {
                    if (response.data.items) {
                        app.searchResult = response.data;
                        app.searchResult.items.map(item => {
                            if (
                                item.pagemap &&
                                item.pagemap.cse_image &&
                                item.pagemap.cse_image[0] &&
                                item.pagemap.cse_image[0].src
                            ) {
                                item.src = item.pagemap.cse_image[0].src;
                            } else {
                                item.src = null;
                            }

                            return item;
                        });
                        app.$emit("quotes", app.searchResult.items);
                        app.$emit("Information", app.searchResult.searchInformation);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        clicked($this) {
            if ($this.srcElement.parentElement.classList.length > 1) {
                $($this.srcElement.parentElement).removeClass("selected");
            } else {
                $($this.srcElement.parentElement).addClass("selected");
            }
        },
        OpenNav() {

            //$('#nav-btn').hide()
            document.getElementById("mobile-nav").style.width = "300px";
            //document.getElementById("wrapper").style.display ="block";
            document.getElementById("body").style.overflowX = "visible";
            document.getElementById("body").style.position = "fixed";
        },
        Close() {
            //$('#mobile-nav').show()
            document.getElementById("mobile-nav").style.width = "0";
            document.getElementById("body").removeAttribute("style");
        }

    }
};
</script>

<style lang="scss" scoped>
header {
    #headerSectionMob {
        display: none;
    }
    background-color: #4d4d4d;
    .top {
        display: flex;
        flex-direction: row;
        -webkit-box-pack: justify;
        justify-content: space-between;
        padding: 0.6rem 15px;
        #contact-numbers-container {
            margin-right: 5rem;
            p {
                color: white;
                font-weight: 600;
                font-size: 17px;
                margin-bottom: 0px;
                span {
                    margin-right: 2rem;
                }
            }
        }
        .search-box {
            display: flex;
            input {
                border-radius: 20px;
                font-size: 18px;
                border: none;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                max-width: 100%;
                padding: 6px 11px 4px;
            }
            button {
                background: #fff;
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                font-size: 20px;
                padding: 1px 20px;
                margin-left: -2px;
            }
        }
        #logo-container {
            p {
                font-weight: bold;
                font-size: 24px;
                color: white;
                margin-bottom: 0px;
            }
        }
    }
    img.logo {
        /*max-height: 65px;*/
        width:100%;
    }
    .navbar {
        background-color: white;
        border-bottom: 1px solid #4d4d4d;
        padding-bottom: 1px;
        padding-top: 1px;
        margin-bottom: 10px;
        a {
            color: #4d4d4d !important;
        }
        .nav-link i {
            font-weight: 600;
            font-size: 20px;
        }
    }
    #overlayWrapper {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.32);
        width: 100%;
        height: 100vh;
        display: none;
        top: 0;
        transition: background-color .5s;
        z-index: 1;
    }
}

.mr-1 {
    margin-right: 1px;
}
</style>
